import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ILocale } from '../types/ILocale';

export interface IGetLocalesParams {
}

export interface IGetLocalesResult {
  locales: ILocale[];
}

export class GetLocalesRequest extends Request<IGetLocalesParams, IGetLocalesResult> {
  constructor(params: IGetLocalesParams = {}) {
    super('getLocales', params);
  }
}
